import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { CelebrateWinComponent } from "slotworks/components/celebrate-win/celebrate-win-component";

export class DMFCelebrateWinComponentFactory implements ComponentFactory {

    constructor(protected celebrateWinComponentType: typeof CelebrateWinComponent) { /* .. */ }

    public build(): AbstractComponent {

        const component = new this.celebrateWinComponentType({
            totalCountupTime: 0,
            winRanges: [
                { id: "LOW", from: 0, to: 5 },
                { id: "MID", from: 5,  to: 16 }
            ]
        });

        return component;
    }
}
